// Tiny CSV export helper — turns an array of row objects into a downloaded .csv.
// Values that are arrays are joined with "|" (matching CsvImportDialog's list type).

function escape(value) {
  if (value == null) return "";
  if (Array.isArray(value)) value = value.join("|");
  const s = String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportCsv({ filename, headers, rows, mapRow }) {
  const headerLine = headers.map(h => h.header).join(",");
  const bodyLines = rows.map(r => {
    const obj = mapRow ? mapRow(r) : r;
    return headers.map(h => escape(obj[h.key])).join(",");
  });
  const blob = new Blob([headerLine + "\n" + bodyLines.join("\n") + "\n"], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filename}-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
